import React, { useState }  from 'react';
import { useObserver } from "mobx-react";
import { Box, Button, Card, CardActions, CardContent, Dialog, CircularProgress, TextField } from '@material-ui/core';
import { stores } from 'mobx-store';
import { RequestStatus } from 'components/GeneralFormView/types';
import Snackbar from '@material-ui/core/Snackbar';
import { AddAccumulationProps } from './types';
import {
    translate,
  } from '../../helperFunctions/translation';
const AddOnlineAccumulation: React.FC<AddAccumulationProps> = (props: AddAccumulationProps) => {
    const [amount, setAmount] = useState(0);
    const [msg, setMsg] = useState("");
    const [open, setOpen] = useState(false);
    const {
        userManagementStore
    } = stores;
    const {
        handleClose,
        modalOpen,
        userId
    } = props;
    const setInput = (setter: React.Dispatch<React.SetStateAction<any>>) => 
    (event: React.ChangeEvent<HTMLInputElement>) => {
        setter(event.target.value)
    };
    const addOnlineUserAccumulation = async () => {
        try {
            await userManagementStore.addOnlineUserAccumulation(`${userId}`, amount);
            setAmount(0);
            setMsg(translate('createdMessage'));
            handleClose();
        } catch (error) {
            setMsg(error || translate("invalidValue"));
        } finally {
            setOpen(true);
        }
    };
    return useObserver(() => (
        <Dialog
            open={modalOpen}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
            fullWidth
            >
            <Card>
                <CardContent>
                    <h2>{translate('addAccumulation')}</h2>
                <TextField
                    value={amount}
                    onChange={setInput(setAmount)}
                    autoFocus
                    margin="dense"
                    id="amount"
                    type="number"
                    label={translate("points")}
                    fullWidth
                />
            </CardContent>
            <CardActions>
                <Button
                    variant="contained"
                    color="primary"
                    disabled={!amount || !userId}
                    onClick={addOnlineUserAccumulation}
                >
                    {
                        userManagementStore.state == RequestStatus.LOADING ? 
                        <CircularProgress size="1.2rem" color="inherit" /> : 
                        translate("Submit")
                    }
                </Button>
                <Snackbar
                    open={open} 
                    autoHideDuration={6000}
                    onClose={() => setOpen(false)}
                    message={msg}
                />
            </CardActions>
        </Card>
    </Dialog>
    ));
}
export default AddOnlineAccumulation;